import { render } from "./AddEditModal.vue?vue&type=template&id=bdfe0968&scoped=true&ts=true"
import script from "./AddEditModal.vue?vue&type=script&lang=ts"
export * from "./AddEditModal.vue?vue&type=script&lang=ts"

import "./AddEditModal.vue?vue&type=style&index=0&id=bdfe0968&lang=scss&scoped=true"
import "./AddEditModal.vue?vue&type=style&index=1&id=bdfe0968&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdfe0968"]])

export default __exports__